module.exports = __webpack_public_path__ + "static/media/rs_jing_tian.d7635876.png";